import { initializeConnector } from "@web3-react/core";
import { LedgerWallet } from "./lib/ledgerWallet";
import { getEnv } from "@bkry/bowline-utils";
import { MAINNET_CHAINS, TESTNET_CHAINS } from "./chains";
export const [ledgerWallet, hooks] = initializeConnector((actions) => {
  const REACT_APP_INFURA_ID = getEnv("REACT_APP_INFURA_ID");
  const rpc = {
    1:
      MAINNET_CHAINS[1]?.urls?.[0] ||
      `https://mainnet.infura.io/v3/${REACT_APP_INFURA_ID}`,
    5:
      TESTNET_CHAINS[5]?.urls?.[0] ||
      `https://goerli.infura.io/v3/${REACT_APP_INFURA_ID}`,
    137: MAINNET_CHAINS[137]?.urls?.[0] || `https://polygon-rpc.com`,
    80002: TESTNET_CHAINS[80002]?.urls?.[0] || undefined,
    11155111:
      TESTNET_CHAINS[11155111]?.urls?.[0] ||
      `https://sepolia.infura.io/v3/${REACT_APP_INFURA_ID}`,
  };

  return new LedgerWallet({
    actions,
    options: {
      rpc: REACT_APP_INFURA_ID ? rpc : {},
      chainId: getEnv("REACT_APP_MAINNET") ? 1 : 11155111,
      chainHex: getEnv("REACT_APP_MAINNET") ? "0x1" : "0xAA36A7",
    },
  });
});
